import { create } from "zustand";

type ModalStore = {
  isOpen: boolean;
  onOpen: (studySetId: string) => void;
  onClose: () => void;
  studySetId: string;
};

const useImageCompatibilityWarningModal = create<ModalStore>((set) => ({
  isOpen: false,
  onOpen: (studySetId: string) => set({ isOpen: true, studySetId }),
  onClose: () => set({ isOpen: false }),
  studySetId: "",
}));

export default useImageCompatibilityWarningModal;
